import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/RegistrationForm.css';

// Imtihon fanlari toifalari (Maxsus imtihon, Chet tili, Mutaxassislik fanlari, Fanlar farqi)
const examCategories = [
  {
    groupName: 'Maxsus imtihon',
    items: [
      {
        code: 'maxsus_imtihon',
        name: 'Maxsus imtihon - Davlat va jamiyat qurilishi tizimini takomillashtirish, qonun ustuvorligi, iqtisodiyotni rivojlantirish va liberallashtirish hamda ijtimoiy rivojlanishning ilmiy asoslari va amaliy yoʻnalishlari'
      }
    ]
  },
  {
    groupName: 'Malakaviy imtihon (Chet tili)',
    items: [
      { code: 'ingliz_tili', name: 'Xorijiy til (ingliz tili)' },
      { code: 'nemis_tili', name: 'Xorijiy til (nemis tili)' },
      { code: 'fransuz_tili', name: 'Xorijiy til (fransuz tili)' },
      { code: 'rus_tili', name: 'Xorijiy til (rus tili)' },
      { code: 'xitoy_tili', name: 'Xorijiy til (xitoy tili)' },
      { code: 'arab_tili', name: 'Xorijiy til (arab tili)' },
      { code: 'ispan_tili', name: 'Xorijiy til (ispan tili)' }
    ]
  },
  {
    groupName: 'Malakaviy imtihon (Mutaxassislik fanlari)',
    items: [
      { code: '01.01.01', name: '01.01.01 - Matematik analiz' },
      { code: '01.01.02', name: '01.01.02 - Differensial tenglamalar va matematik fizika' },
      { code: '01.04.04', name: '01.04.04 - Fizik elektronika' },
      { code: '01.04.10', name: '01.04.10 - Yarimoʻtkazgichlar fizikasi' },
      { code: '01.04.11', name: '01.04.11 - Lazer fizikasi' },
      { code: '03.00.05', name: '03.00.05 - Botanika' },
      { code: '03.00.08', name: '03.00.08 - Odam va hayvonlar fiziologiyasi' },
      { code: '05.05.06', name: '05.05.06 - Qayta tiklanadigan energiya turlari asosidagi energiya qurilmalari' },
      { code: '07.00.01', name: '07.00.01 - Oʻzbekiston tarixi' },
      { code: '07.00.07', name: '07.00.07 - Etnografiya, etnologiya va antropologiya' },
      { code: '08.00.05', name: '08.00.05 - Xizmat koʻrsatish tarmoqlari iqtisodiyoti' },
      { code: '08.00.06', name: '08.00.06 - Ekonometrika va statistika' },
      { code: '08.00.11', name: '08.00.11 - Marketing' },
      { code: '08.00.12', name: '08.00.12 - Mintaqaviy iqtisodiyot' },
      { code: '08.00.13', name: '08.00.13 - Menejment' },
      { code: '08.00.17', name: '08.00.17 - Turizm va mehmonxona faoliyati' },
      { code: '10.00.01', name: '10.00.01 - Oʻzbek tili' },
      { code: '10.00.02', name: '10.00.02 - Oʻzbek mumtoz adabiyoti' },
      { code: '10.00.06', name: '10.00.06 - Qiyosiy adabiyotshunoslik va tarjimashunoslik' },
      { code: '13.00.01', name: '13.00.01 - Pedagogika nazariyasi. Pedagogik taʼlimotlar tarixi' },
      { code: '13.00.02', name: '13.00.02 - Taʼlim va tarbiya nazariyasi hamda metodikasi (sohalar boʻyicha)' },
      { code: '13.00.06', name: '13.00.06 - Raqamli taʼlim nazariyasi va metodikasi (taʼlim sohalari va bosqichlari boʻyicha)' },
      { code: '13.00.07', name: '13.00.07 - Taʼlimda menejment' }
    ]
  },
  {
    groupName: 'Mutaxassislikka qoʻshimcha fanlar (Fanlar farqi)',
    items: [
      { code: 'qoshimcha_adabiyot', name: 'Adabiyotshunoslik' },
      { code: 'qoshimcha_amaliy_ekonometrika', name: 'Amaliy ekonometrika' },
      { code: 'qoshimcha_analitik_mexanika', name: 'Analitik mexanikaning tanlangan boblari' },
      { code: 'qoshimcha_areal_lingvistika', name: 'Areal lingvistika' },
      { code: 'qoshimcha_biznes_raqamli', name: 'Biznesda raqamli boshqarish' },
      { code: 'qoshimcha_dorivor_osimliklar', name: 'Dorivor oʻsimliklarni introduksiyasi va akklimatizatsiyasi' },
      { code: 'qoshimcha_ekonometrika_statistika', name: 'Ekonometrika va statistika' },
      { code: 'qoshimcha_ekonometrika_2', name: 'Ekonometrika-2' },
      { code: 'qoshimcha_etnografiya', name: 'Etnografiya, etnologiya va antropologiya' },
      { code: 'qoshimcha_globallashuv', name: 'Globallashuv sharoitida Oʻzbekiston va Jahon mamlakatlari hamkorligi' },
      { code: 'qoshimcha_ijtimoiy_modellashtirish', name: 'Ijtimoiy-iqtisodiy jarayonlarni modellashtirish va prognozlash' },
      { code: 'qoshimcha_jahon_adabiyoti', name: 'Jahon adabiyoti muammolari' },
      { code: 'qoshimcha_kognitiv_psixologiya', name: 'Kognitiv psixologiya' },
      { code: 'qoshimcha_lingvokulturologiya', name: 'Lingvokulturologiya va matn tilshunosligi' },
      { code: 'qoshimcha_mahalliy_mintaqaviy', name: 'Mahalliy va mintaqaviy rivojlanish iqtisodiyoti' },
      { code: 'qoshimcha_marketing', name: 'Marketing' },
      { code: 'qoshimcha_materiallar_strukturasi', name: 'Materiallar strukturasi va strukturaviy tahlil' },
      { code: 'qoshimcha_mikrob_biotexnologiya', name: 'Mikrob biotexnologiya' },
      { code: 'qoshimcha_mintaqaviy_iqtisodiyot', name: 'Mintaqaviy iqtisodiyot' }
    ]
  }
];

// Maxsus moslashtirilgan dropdown komponenti (Chapga qochmasdan toʻliq input ostida ochiladi, matnlarni chiroyli sindiradi)
function CustomDropdownSelect({
  id,
  name,
  value,
  onChange,
  categories,
  error,
  placeholder = "Fan yoki ixtisoslikni tanlang..."
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  // Tashqariga bosilganda yopish
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Ochilganda qidiruv maydoniga fokus qaratish
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 50);
    } else {
      setSearchTerm('');
    }
  }, [isOpen]);

  const handleSelect = (itemValue) => {
    onChange({
      target: {
        name: name,
        value: itemValue
      }
    });
    setIsOpen(false);
  };

  // Qidiruv boʻyicha filtrlash
  const term = searchTerm.toLowerCase().trim();
  const filteredCategories = categories.map(group => {
    const matchesGroup = group.groupName.toLowerCase().includes(term);
    const matchedItems = group.items.filter(item =>
      matchesGroup ||
      item.name.toLowerCase().includes(term) ||
      item.code.toLowerCase().includes(term)
    );
    return {
      ...group,
      items: matchedItems
    };
  }).filter(group => group.items.length > 0);

  // Tanlangan element qaysi toifaga mansubligini aniqlash
  const selectedGroup = categories.find(group =>
    group.items.some(item => item.name === value)
  );

  return (
    <div className={`custom-dropdown-container ${error ? 'has-error' : ''} ${isOpen ? 'is-open' : ''}`} ref={dropdownRef}>
      <input type="hidden" name={name} value={value || ''} id={id} />

      <div
        className="custom-dropdown-trigger"
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsOpen(!isOpen);
          } else if (e.key === 'Escape') {
            setIsOpen(false);
          }
        }}
      >
        <div className="custom-dropdown-trigger-content">
          {value ? (
            <div className="custom-dropdown-selected-wrap">
              {selectedGroup && (
                <span className="custom-dropdown-tag-pill">{selectedGroup.groupName}</span>
              )}
              <span className="custom-dropdown-value-text">{value}</span>
            </div>
          ) : (
            <span className="custom-dropdown-placeholder">{placeholder}</span>
          )}
        </div>
        <div className="custom-dropdown-arrow-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}>
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>

      {isOpen && (
        <div className="custom-dropdown-menu">
          <div className="custom-dropdown-search-wrap">
            <svg className="dropdown-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              ref={searchInputRef}
              type="text"
              className="custom-dropdown-search-input"
              placeholder="Fan nomi yoki shifrini qidirish (masalan: 13.00, ingliz, tarix)..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => {
                if (e.key === 'Escape') {
                  setIsOpen(false);
                }
              }}
            />
            {searchTerm && (
              <button
                type="button"
                className="custom-dropdown-search-clear"
                onClick={(e) => {
                  e.stopPropagation();
                  setSearchTerm('');
                  searchInputRef.current?.focus();
                }}
              >
                ✕
              </button>
            )}
          </div>

          <div className="custom-dropdown-list">
            {filteredCategories.length === 0 ? (
              <div className="custom-dropdown-empty">
                <p>"{searchTerm}" boʻyicha fan yoki ixtisoslik topilmadi.</p>
              </div>
            ) : (
              filteredCategories.map(group => (
                <div key={group.groupName} className="custom-dropdown-group">
                  <div className="custom-dropdown-group-header">
                    <span className="group-title-text">{group.groupName}</span>
                    <span className="group-count-badge">{group.items.length}</span>
                  </div>
                  <div className="custom-dropdown-group-items">
                    {group.items.map(item => {
                      const isSelected = item.name === value;
                      return (
                        <div
                          key={item.code}
                          className={`custom-dropdown-item ${isSelected ? 'is-selected' : ''}`}
                          onClick={() => handleSelect(item.name)}
                          role="option"
                          aria-selected={isSelected}
                        >
                          <div className="custom-dropdown-item-content">
                            <span className="custom-dropdown-item-title">{item.name}</span>
                          </div>
                          {isSelected && (
                            <svg className="custom-dropdown-check-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// Format phone number to Uzbekistan standard: +998 (XX) XXX-XX-XX
const formatUzbekPhoneNumber = (value) => {
  if (!value) return '+998 ';
  let digits = value.replace(/\D/g, '');
  if (digits.startsWith('998')) {
    digits = digits.slice(3);
  }
  digits = digits.slice(0, 9);
  if (digits.length === 0) {
    return '+998 ';
  }
  let formatted = '+998 ';
  if (digits.length > 0) {
    formatted += `(${digits.slice(0, 2)}`;
  }
  if (digits.length >= 2) {
    formatted += ') ';
  }
  if (digits.length > 2) {
    formatted += digits.slice(2, 5);
  }
  if (digits.length >= 5) {
    formatted += '-';
  }
  if (digits.length > 5) {
    formatted += digits.slice(5, 7);
  }
  if (digits.length >= 7) {
    formatted += '-';
  }
  if (digits.length > 7) {
    formatted += digits.slice(7, 9);
  }
  return formatted;
};

export default function RegistrationForm({ token, user }) {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [applicantType, setApplicantType] = useState('Ushbu taʼlim muassasasi');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [submittedSuccess, setSubmittedSuccess] = useState(false);

  // Check if service deadline has expired
  const [isServiceExpired, setIsServiceExpired] = useState(() => {
    const deadline = new Date('2026-10-25T23:59:59.000Z').getTime();
    return Date.now() > deadline;
  });

  useEffect(() => {
    axios.get('/api/services/phd-exam')
      .then(res => {
        if (res.data?.service?.deadline) {
          const d = new Date(res.data.service.deadline).getTime();
          if (!isNaN(d)) {
            setIsServiceExpired(Date.now() > d);
          }
        }
      })
      .catch(() => {});
  }, []);

  const [formData, setFormData] = useState({
    fullName: (user && user.name) || '',
    birthDate: '',
    passportNumber: '',
    otmName: 'Turon universiteti',
    positionAndTitle: 'Doktorant-tadqiqotchi',
    specialization: 'Xorijiy til (ingliz tili)',
    dissertationTopic: '',
    advisorInfo: '',
    phoneNumber: '+998 ',
    email: (user && user.email) || '',
    documents: {
      application: null,
      oakBulletin: null,
      phd_certificate: null,
      passport: null,
      paymentReceipt: null,
      referralLetter: null
    }
  });

  useEffect(() => {
    if (user) {
      setFormData(prev => ({
        ...prev,
        fullName: prev.fullName || user.name || '',
        email: prev.email || user.email || ''
      }));
    }
  }, [user]);

  // Administrator hisobidan ariza topshirishni toʻliq cheklash
  if (user && user.role === 'admin') {
    return (
      <div className="registration-page-wrapper">
        <div className="container" style={{ padding: '80px 20px', maxWidth: '680px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{ background: '#fff', borderRadius: '20px', padding: '48px 36px', boxShadow: '0 12px 30px rgba(15,43,92,0.08)', border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: '56px', marginBottom: '18px' }}>🛡️</div>
            <h2 style={{ fontSize: '24px', color: '#0f2b5c', marginBottom: '14px', fontWeight: '800' }}>
              Administrator hisobi: Ariza topshirish cheklangan
            </h2>
            <p style={{ color: '#475569', fontSize: '15.5px', lineHeight: '1.65', marginBottom: '28px' }}>
              Siz tizimga <strong>Bosh Administrator (Portal maʼmuriyati)</strong> sifatida kirgansiz. Administrator tizimdagi xizmatlarni boshqarish, muddatlarni belgilash va arizalarni tekshirish vakolatiga ega. 
              <br /><br />
              Xizmatdan foydalanish (ariza topshirish) esa faqat talabgorlar (tadqiqotchilar) yoki roʻyxatdan oʻtmagan mehmonlar uchun moʻljallangan.
            </p>
            <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                className="btn-primary"
                onClick={() => navigate('/admin')}
                style={{ padding: '12px 24px', background: '#0f2b5c', color: '#fff', border: 'none', borderRadius: '10px', fontWeight: '700', fontSize: '14.5px', cursor: 'pointer' }}
              >
                ← Admin boshqaruv paneliga qaytish
              </button>
              <button
                className="btn-outline"
                onClick={() => navigate('/portal')}
                style={{ padding: '12px 24px', background: '#f8fafc', color: '#1e40af', border: '1px solid #bfdbfe', borderRadius: '10px', fontWeight: '700', fontSize: '14.5px', cursor: 'pointer' }}
              >
                🌐 Portalni koʻrish
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Qabul muddati yakunlangan holatda talabgorlar ariza topshira olmaydi
  if (isServiceExpired && user?.role !== 'admin') {
    return (
      <div className="registration-page-wrapper">
        <div className="container" style={{ padding: '80px 20px', maxWidth: '680px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{ background: '#fff', borderRadius: '20px', padding: '48px 36px', boxShadow: '0 12px 30px rgba(15,43,92,0.08)', border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: '56px', marginBottom: '18px' }}>⏰</div>
            <h2 style={{ fontSize: '24px', color: '#0f2b5c', marginBottom: '14px', fontWeight: '800' }}>
              Qabul muddati yakunlangan
            </h2>
            <p style={{ color: '#475569', fontSize: '15.5px', lineHeight: '1.65', marginBottom: '28px' }}>
              <strong>«Chet tilidan va mutaxassislik fanlaridan malakaviy imtihon»</strong> xizmati boʻyicha rasmiy arizalar qabul qilish muddati yakunlangan. Hozirgi kunda yangi arizalar qabul qilinmaydi.
            </p>
            <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                className="btn-primary"
                onClick={() => navigate('/services/phd-exam')}
                style={{ padding: '12px 24px', background: '#0284c7', color: '#fff', border: 'none', borderRadius: '10px', fontWeight: '700', fontSize: '14.5px', cursor: 'pointer' }}
              >
                ← Xizmat sahifasiga qaytish
              </button>
              <button
                className="btn-outline"
                onClick={() => navigate('/')}
                style={{ padding: '12px 24px', background: '#f8fafc', color: '#1e40af', border: '1px solid #bfdbfe', borderRadius: '10px', fontWeight: '700', fontSize: '14.5px', cursor: 'pointer' }}
              >
                🌐 Asosiy portal
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handlePhoneChange = (e) => {
    const rawVal = e.target.value;
    if (rawVal.length < 5 && !rawVal.startsWith('+998')) {
      setFormData(prev => ({ ...prev, phoneNumber: '+998 ' }));
      return;
    }
    const formatted = formatUzbekPhoneNumber(rawVal);
    setFormData(prev => ({ ...prev, phoneNumber: formatted }));
    if (errors.phoneNumber) {
      setErrors(prev => ({ ...prev, phoneNumber: '' }));
    }
  };

  const handleFileChange = (e, fileKey) => {
    const file = e.target.files[0];
    if (file) {
      // Faqat PDF formatini tekshirish
      const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
      if (!isPdf) {
        setErrors(prev => ({ ...prev, [fileKey]: 'Faqat PDF formatidagi hujjat qabul qilinadi!' }));
        return;
      }
      // Qat'iy 3 MB cheklovi
      if (file.size > 3 * 1024 * 1024) {
        const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
        setErrors(prev => ({ ...prev, [fileKey]: `Fayl hajmi 3 MB dan oshmasligi lozim! (Siz tanlagan fayl hajmi: ${sizeMb} MB). Iltimos, faylni siqib qayta yuklang.` }));
        return;
      }
      setFormData(prev => ({
        ...prev,
        documents: {
          ...prev.documents,
          [fileKey]: file
        }
      }));
      setErrors(prev => ({ ...prev, [fileKey]: '' }));
    }
  };

  const validateStep1 = () => {
    const errs = {};
    if (!formData.fullName.trim()) errs.fullName = 'F.I.Sh. toʻliq kiritilishi shart';
    if (!formData.birthDate) errs.birthDate = 'Tugʻilgan sana kiritilishi majburiy';
    if (!formData.passportNumber.trim()) {
      errs.passportNumber = 'JSHSHIR raqami kiritilishi majburiy';
    } else if (formData.passportNumber.replace(/\D/g, '').length !== 14) {
      errs.passportNumber = 'JSHSHIR aynan 14 ta raqamdan iborat boʻlishi shart';
    }
    if (!formData.otmName.trim()) errs.otmName = 'OTM yoki ITM nomi kiritilishi majburiy';
    if (!formData.positionAndTitle.trim()) errs.positionAndTitle = 'Ish joyi va lavozimi kiritilishi majburiy';
    if (!formData.specialization.trim()) errs.specialization = 'Ixtisoslik tanlanishi majburiy';
    if (!formData.dissertationTopic.trim()) errs.dissertationTopic = 'Dissertatsiya mavzusi kiritilishi majburiy';
    if (!formData.advisorInfo.trim()) errs.advisorInfo = 'Ilmiy maslahatchi/rahbar maʼlumotlari kiritilishi majburiy';
    
    // Telefon raqami qat'iy tekshiruvi (Oʻzbekiston formati: 998 + 9 raqam = 12 raqam)
    const cleanDigits = (formData.phoneNumber || '').replace(/\D/g, '');
    if (cleanDigits.length !== 12 || !cleanDigits.startsWith('998')) {
      errs.phoneNumber = 'Telefon raqamini toʻliq kiriting: +998 (XX) XXX-XX-XX';
    } else {
      const opCode = cleanDigits.slice(3, 5);
      const validCodes = ['90', '91', '93', '94', '95', '97', '98', '99', '88', '77', '33', '50', '55', '70', '71', '72', '73', '74', '75', '76', '79'];
      if (!validCodes.includes(opCode)) {
        errs.phoneNumber = 'Oʻzbekiston aloqa operatori kodi (90, 91, 93, 94, 99, 88, 77, 33...) notoʻgʻri kiritildi';
      }
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const validateStep2 = () => {
    const errs = {};
    if (!formData.specialization) {
      errs.specialization = 'Belgilangan fan nomi tanlanishi shart';
    }
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const validateStep3 = () => {
    const errs = {};
    if (!formData.documents.application) errs.application = 'Ariza faylini yuklash majburiy';
    if (!formData.documents.oakBulletin) errs.oakBulletin = 'OAK Byulleteni nusxasini yuklash majburiy';
    if (!formData.documents.phd_certificate) errs.phd_certificate = 'PhD talabasi ekanligi toʻgʻrisida maʼlumotnoma majburiy';
    if (!formData.documents.passport) errs.passport = 'Pasport nusxasini yuklash majburiy';

    if (applicantType === 'Boshqa taʼlim muassasasi') {
      if (!formData.documents.paymentReceipt) errs.paymentReceipt = 'Toʻlov kvitansiyasini yuklash majburiy';
      if (!formData.documents.referralLetter) errs.referralLetter = 'Yoʻllanma xatni yuklash majburiy';
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleNext = () => {
    if (step === 1) {
      if (validateStep1()) setStep(2);
    } else if (step === 2) {
      if (validateStep2()) setStep(3);
    }
  };

  const handlePrev = () => {
    if (step > 1) {
      setStep(step - 1);
      setErrors({});
    }
  };

  const handleSubmit = async () => {
    if (!validateStep3()) return;

    try {
      setLoading(true);
      setErrors({});

      const data = new FormData();
      data.append('fullName', formData.fullName || (user && user.name) || '');
      data.append('birthDate', formData.birthDate);
      data.append('passportNumber', formData.passportNumber);
      data.append('otmName', formData.otmName);
      data.append('positionAndTitle', formData.positionAndTitle);
      data.append('specialization', formData.specialization);
      data.append('dissertationTopic', formData.dissertationTopic);
      data.append('advisorInfo', formData.advisorInfo);
      data.append('phoneNumber', formData.phoneNumber);
      data.append('email', (user && user.email) || formData.email || `applicant_${Date.now()}@turon.edu.uz`);
      if (user && user.id) {
        data.append('userId', user.id);
      }
      data.append('applicantType', applicantType);

      if (formData.documents.application) data.append('application', formData.documents.application);
      if (formData.documents.oakBulletin) data.append('oakBulletin', formData.documents.oakBulletin);
      if (formData.documents.phd_certificate) data.append('phd_certificate', formData.documents.phd_certificate);
      if (formData.documents.passport) data.append('passport', formData.documents.passport);
      if (formData.documents.paymentReceipt) data.append('paymentReceipt', formData.documents.paymentReceipt);
      if (formData.documents.referralLetter) data.append('referralLetter', formData.documents.referralLetter);

      const res = await axios.post('/api/applicant/register', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        }
      });

      if (res.data && (res.data.applicantId || res.data.applicant?.id)) {
        const appId = res.data.applicantId || res.data.applicant?.id;
        localStorage.setItem('myApplicantId', appId);
        if (res.data.applicant) {
          localStorage.setItem('myApplicantData', JSON.stringify(res.data.applicant));
        }
      }

      setSubmittedSuccess(true);
      setTimeout(() => {
        navigate('/dashboard');
      }, 1600);
    } catch (err) {
      console.error('Registration error:', err);
      setErrors({
        submit: err.response?.data?.error || 'Arizani yuborishda xatolik yuz berdi. Iltimos, qaytadan urinib koʻring.'
      });
      setLoading(false);
    }
  };

  return (
    <div className="registration-page-wrapper">
      {/* Sayt boʻylab yoʻnaltiruvchi yoʻlakcha */}
      <div className="portal-breadcrumb-strip">
        <div className="container">
          <div className="breadcrumb-nav">
            <Link to="/" className="crumb-link" title="Bosh sahifaga qaytish">Bosh sahifa</Link>
            <span className="crumb-arrow">/</span>
            <Link to="/" className="crumb-link" title="Xizmatlar roʻyxatiga oʻtish">Xizmatlar</Link>
            <span className="crumb-arrow">/</span>
            <Link to="/services/phd-exam" className="crumb-link" title="Xizmat tafsilotlariga oʻtish">
              Chet tilidan va mutaxassislik fanlaridan malakaviy imtihon
            </Link>
            <span className="crumb-arrow">/</span>
            <span className="crumb-current">Ariza berish</span>
          </div>
        </div>
      </div>

      <div className="container reg-form-container">
        {/* Asosiy karta */}
        <div className="registration-main-card">
          {/* Sarlavha */}
          <div className="reg-title-header">
            <h1 className="reg-page-heading">Chet tilidan va mutaxassislik fanlaridan malakaviy imtihon.</h1>
          </div>

          {/* Bosqichlar indikatori */}
          <div className="reg-stepper-track">
            {/* 1-bosqich */}
            <div className={`stepper-node ${step >= 1 ? 'completed' : ''} ${step === 1 ? 'current' : ''}`}>
              <div className="step-circle-badge">1</div>
              <span className="step-node-label">Shaxsiy maʼlumotlar</span>
            </div>

            {/* Chiziq 1-2 */}
            <div className={`stepper-line ${step >= 2 ? 'active' : ''}`}></div>

            {/* 2-bosqich */}
            <div className={`stepper-node ${step >= 2 ? 'completed' : ''} ${step === 2 ? 'current' : ''}`}>
              <div className="step-circle-badge">2</div>
              <span className="step-node-label">Belgilangan fan nomi</span>
            </div>

            {/* Chiziq 2-3 */}
            <div className={`stepper-line ${step >= 3 ? 'active' : ''}`}></div>

            {/* 3-bosqich */}
            <div className={`stepper-node ${step === 3 ? 'completed current' : ''}`}>
              <div className="step-circle-badge">3</div>
              <span className="step-node-label">Fayl yuklash</span>
            </div>
          </div>

          {/* Muvaffaqiyatli qabul qilinganlik modali */}
          {submittedSuccess && (
            <div className="reg-success-overlay">
              <div className="success-dialog-box">
                <div className="success-icon-badge">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                <h2>Arizangiz muvaffaqiyatli qabul qilindi!</h2>
                <p>
                  Arizangiz Turon universiteti Ilmiy boʻlimiga topshirildi.
                  Shaxsiy kabinetingizga yoʻnaltirilmoqda...
                </p>
                <div className="loading-spinner-ring"></div>
              </div>
            </div>
          )}

          {errors.submit && (
            <div className="alert-box-error">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
              <span>{errors.submit}</span>
            </div>
          )}

          {/* 1-BOSQICH: Shaxsiy maʼlumotlar */}
          {step === 1 && (
            <div className="step-fields-body">
              {/* F.I.Sh. */}
              <div className="form-row-group">
                <label className="form-label-cell" htmlFor="fullName">
                  F.I.Sh. <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <input
                    id="fullName"
                    type="text"
                    name="fullName"
                    placeholder="Aliyev Anvarbek Anvarovich"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className={errors.fullName ? 'has-error' : ''}
                  />
                  <span className="field-hint-text">Toʻliq ismingizni kiriting. Masalan: "Aliyev Anvarbek Anvarovich"</span>
                  {errors.fullName && <span className="field-error-text">{errors.fullName}</span>}
                </div>
              </div>

              {/* Tugʻilgan sana */}
              <div className="form-row-group">
                <label className="form-label-cell" htmlFor="birthDate">
                  Tugʻilgan sana <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <input
                    id="birthDate"
                    type="date"
                    name="birthDate"
                    placeholder="01.01.2000"
                    value={formData.birthDate}
                    onChange={handleInputChange}
                    className={errors.birthDate ? 'has-error' : ''}
                  />
                  <span className="field-hint-text">Tugʻilgan sanangizni kiriting. Masalan: "01.01.2000"</span>
                  {errors.birthDate && <span className="field-error-text">{errors.birthDate}</span>}
                </div>
              </div>

              {/* JSHSHIR */}
              <div className="form-row-group">
                <label className="form-label-cell" htmlFor="passportNumber">
                  JSHSHIR <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <div className="input-with-counter">
                    <input
                      id="passportNumber"
                      type="text"
                      name="passportNumber"
                      maxLength="14"
                      placeholder="12345678901234"
                      value={formData.passportNumber}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, '');
                        setFormData(prev => ({ ...prev, passportNumber: val }));
                      }}
                      className={errors.passportNumber ? 'has-error' : ''}
                    />
                    <span className="counter-badge">{formData.passportNumber.length}/14</span>
                  </div>
                  <span className="field-hint-text">JSHSHIR raqamingizni kiriting. Masalan: "12345678901234"</span>
                  {errors.passportNumber && <span className="field-error-text">{errors.passportNumber}</span>}
                </div>
              </div>

              {/* Biriktirilgan OTM yoki ITM nomi */}
              <div className="form-row-group">
                <label className="form-label-cell" htmlFor="otmName">
                  Biriktirilgan OTM yoki ITM nomi <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <input
                    id="otmName"
                    type="text"
                    name="otmName"
                    placeholder="Masalan: Turon universiteti"
                    value={formData.otmName}
                    onChange={handleInputChange}
                    className={errors.otmName ? 'has-error' : ''}
                  />
                  {errors.otmName && <span className="field-error-text">{errors.otmName}</span>}
                </div>
              </div>

              {/* Ish joyi va lavozimi */}
              <div className="form-row-group">
                <label className="form-label-cell" htmlFor="positionAndTitle">
                  Ish joyi va lavozimi <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <input
                    id="positionAndTitle"
                    type="text"
                    name="positionAndTitle"
                    placeholder="Masalan: Katta oʻqituvchi, tayanch doktorant"
                    value={formData.positionAndTitle}
                    onChange={handleInputChange}
                    className={errors.positionAndTitle ? 'has-error' : ''}
                  />
                  {errors.positionAndTitle && <span className="field-error-text">{errors.positionAndTitle}</span>}
                </div>
              </div>

              {/* Ixtisoslikni tanlang */}
              <div className="form-row-group">
                <label className="form-label-cell" htmlFor="specialization">
                  Ixtisoslikni tanlang <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <CustomDropdownSelect
                    id="specialization"
                    name="specialization"
                    value={formData.specialization}
                    onChange={handleInputChange}
                    categories={examCategories}
                    error={errors.specialization}
                    placeholder="Ixtisoslik yoki fanni tanlang..."
                  />
                  {errors.specialization && <span className="field-error-text">{errors.specialization}</span>}
                </div>
              </div>

              {/* Dissertatsiya mavzusi */}
              <div className="form-row-group">
                <label className="form-label-cell" htmlFor="dissertationTopic">
                  Dissertatsiya mavzusi <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <textarea
                    id="dissertationTopic"
                    name="dissertationTopic"
                    rows="2"
                    placeholder="Dissertatsiya tadqiqot mavzusini toʻliq kiriting"
                    value={formData.dissertationTopic}
                    onChange={handleInputChange}
                    className={errors.dissertationTopic ? 'has-error' : ''}
                  ></textarea>
                  {errors.dissertationTopic && <span className="field-error-text">{errors.dissertationTopic}</span>}
                </div>
              </div>

              {/* Ilmiy maslahatchi/rahbar maʼlumotlari */}
              <div className="form-row-group">
                <label className="form-label-cell" htmlFor="advisorInfo">
                  Ilmiy maslahatchining F.I.Sh., ilmiy darajasi, ilmiy unvoni <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <input
                    id="advisorInfo"
                    type="text"
                    name="advisorInfo"
                    placeholder="Masalan: Xalilov Rustam Samatovich, Filologiya fanlari doktori, Professor"
                    value={formData.advisorInfo}
                    onChange={handleInputChange}
                    className={errors.advisorInfo ? 'has-error' : ''}
                  />
                  {errors.advisorInfo && <span className="field-error-text">{errors.advisorInfo}</span>}
                </div>
              </div>

              {/* Telefon raqam */}
              <div className="form-row-group">
                <label className="form-label-cell" htmlFor="phoneNumber">
                  Telefon raqami <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <input
                    id="phoneNumber"
                    type="tel"
                    inputMode="tel"
                    maxLength={19}
                    name="phoneNumber"
                    placeholder="+998 (90) 123-45-67"
                    value={formData.phoneNumber}
                    onChange={handlePhoneChange}
                    className={errors.phoneNumber ? 'has-error' : ''}
                  />
                  <span className="field-hint-text">Telefon raqamingizni kiriting (+998 XX XXX-XX-XX)</span>
                  {errors.phoneNumber && <span className="field-error-text">{errors.phoneNumber}</span>}
                </div>
              </div>
            </div>
          )}

          {/* 2-BOSQICH: Belgilangan fan nomi */}
          {step === 2 && (
            <div className="step-fields-body">
              <div className="form-row-group single-col-center">
                <label className="form-label-cell prominent" htmlFor="specializationStep2">
                  Belgilangan fan nomi <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <CustomDropdownSelect
                    id="specializationStep2"
                    name="specialization"
                    value={formData.specialization}
                    onChange={handleInputChange}
                    categories={examCategories}
                    error={errors.specialization}
                    placeholder="Belgilangan fan nomini tanlang..."
                  />
                  {errors.specialization && <span className="field-error-text">{errors.specialization}</span>}
                </div>
              </div>

              {/* Ariza namunasini yuklab olish bloki */}
              <div className="sample-app-download-banner">
                <div className="sample-app-left">
                  <div className="sample-app-icon">📝</div>
                  <div className="sample-app-info">
                    <span className="sample-app-tag">RASMIY HUJJAT SHAKLI</span>
                    <strong className="sample-app-title">Ariza (Namunani yuklab olish)</strong>
                    <p className="sample-app-sub">
                      Talabgor universitet rektori nomiga rasmiy ariza namunasini toʻldirib, imzolagan holda keyingi 3-bosqichda tizimga yuklashi lozim.
                    </p>
                  </div>
                </div>
                <div className="sample-app-right">
                  <a
                    href="/Ariza_Namunasi.pdf"
                    download="Ariza Namunasi.pdf"
                    className="btn-sample-download-action"
                    title="Chet tili va mutaxassislik fani boʻyicha rasmiy ariza namunasini yuklab olish"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                    <span>Namunani yuklab olish (PDF)</span>
                  </a>
                </div>
              </div>

              {/* Axborot kartasi: Offline imtihon tartibi */}
              <div className="selected-spec-info-card">
                <div className="spec-icon-display">🏛️</div>
                <div className="spec-info-texts">
                  <h4>Tanlangan fan: <span className="highlight-text">{formData.specialization || 'Tanlanmagan'}</span></h4>
                  {formData.specialization && (
                    <div className="spec-category-tag">
                      Yoʻnalish guruhi: <strong>{examCategories.find(g => g.items.some(i => i.name === formData.specialization))?.groupName || 'Malakaviy imtihon'}</strong>
                    </div>
                  )}
                  <div className="offline-exam-notice-box">
                    <div className="oen-badge">⚠️ MUHIM ESLATMA (OFFLINE IMTIHON TARTIBI)</div>
                    <p className="oen-desc">
                      Ushbu fan boʻyicha imtihon sinovi tizimda onlayn oʻtkazilmaydi. Talabgor portal orqali faqat belgilangan fan boʻyicha ariza va tegishli hujjatlarini yuboradi.
                    </p>
                    <p className="oen-desc" style={{ marginTop: '8px' }}>
                      Arizangiz qabul qilingandan soʻng, universitet (Ilmiy boʻlim) tomonidan imtihon sanasi, vaqti va oʻtkaziladigan xona/auditoriya belgilanadi hamda talabgor universitetga anʼanaviy (offline) tartibda imtihon topshirish uchun chaqiriladi.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* 3-BOSQICH: Fayl yuklash */}
          {step === 3 && (
            <div className="step-fields-body">
              {/* Ariza beruvchi turi */}
              <div className="form-row-group radio-row">
                <label className="form-label-cell">
                  Ariza beruvchi turi <span className="req-star">*</span>
                </label>
                <div className="form-input-cell radio-options-cell">
                  <label className="radio-label-item">
                    <input
                      type="radio"
                      name="applicantType"
                      value="Ushbu taʼlim muassasasi"
                      checked={applicantType === "Ushbu taʼlim muassasasi"}
                      onChange={() => setApplicantType("Ushbu taʼlim muassasasi")}
                    />
                    <span className="custom-radio-mark"></span>
                    <span className="radio-text">Ushbu taʼlim muassasasi (Turon universiteti)</span>
                  </label>

                  <label className="radio-label-item">
                    <input
                      type="radio"
                      name="applicantType"
                      value="Boshqa taʼlim muassasasi"
                      checked={applicantType === "Boshqa taʼlim muassasasi"}
                      onChange={() => setApplicantType("Boshqa taʼlim muassasasi")}
                    />
                    <span className="custom-radio-mark"></span>
                    <span className="radio-text">Boshqa taʼlim muassasasi</span>
                  </label>
                </div>
              </div>

              {/* Boshqa OTMdan ariza beruvchilar uchun qoʻshimcha maydonlar */}
              {applicantType === "Boshqa taʼlim muassasasi" && (
                <>
                  {/* Toʻlov kvitansiyasi */}
                  <div className="form-row-group file-field-row">
                    <label className="form-label-cell" htmlFor="paymentReceipt">
                      Toʻlov kvitansiyasi <span className="req-star">*</span>
                    </label>
                    <div className="form-input-cell">
                      <div className="file-input-wrapper">
                        <input
                          id="paymentReceipt"
                          type="file"
                          accept=".pdf"
                          onChange={(e) => handleFileChange(e, 'paymentReceipt')}
                        />
                        <button type="button" className="btn-choose-file" onClick={() => document.getElementById('paymentReceipt').click()}>
                          Faylni tanlash
                        </button>
                        <span className="file-chosen-name">
                          {formData.documents.paymentReceipt ? formData.documents.paymentReceipt.name : 'Fayl tanlanmagan'}
                        </span>
                      </div>
                      <span className="field-hint-text">
                        Boshqa OTM yoki ITMda tahsil oluvchilar uchun BHMning 1 baravari miqdoridagi toʻlov kvitansiyasi. Hujjat turi: PDF. Maksimal hajm: 3 MB.
                      </span>
                      {errors.paymentReceipt && <span className="field-error-text">{errors.paymentReceipt}</span>}
                    </div>
                  </div>

                  {/* Yoʻllanma xat */}
                  <div className="form-row-group file-field-row">
                    <label className="form-label-cell" htmlFor="referralLetter">
                      Yoʻllanma xat <span className="req-star">*</span>
                    </label>
                    <div className="form-input-cell">
                      <div className="file-input-wrapper">
                        <input
                          id="referralLetter"
                          type="file"
                          accept=".pdf"
                          onChange={(e) => handleFileChange(e, 'referralLetter')}
                        />
                        <button type="button" className="btn-choose-file" onClick={() => document.getElementById('referralLetter').click()}>
                          Faylni tanlash
                        </button>
                        <span className="file-chosen-name">
                          {formData.documents.referralLetter ? formData.documents.referralLetter.name : 'Fayl tanlanmagan'}
                        </span>
                      </div>
                      <span className="field-hint-text">
                        Asosiy ish yoki oʻqish joyi boshqa boʻlgan talabgorlar uchun yoʻllanma xati. Hujjat turi: PDF. Maksimal hajm: 3 MB.
                      </span>
                      {errors.referralLetter && <span className="field-error-text">{errors.referralLetter}</span>}
                    </div>
                  </div>
                </>
              )}

              {/* Ariza (Namuna) */}
              <div className="form-row-group file-field-row">
                <label className="form-label-cell" htmlFor="application">
                  Ariza{' '}
                  <a
                    href="/Ariza_Namunasi.pdf"
                    download="Ariza Namunasi.pdf"
                    className="namuna-link"
                    title="Rasmiy ariza namunasini yuklab olish"
                  >
                    (Namunani yuklab olish)
                  </a>{' '}
                  <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <div className="file-input-wrapper">
                    <input
                      id="application"
                      type="file"
                      accept=".pdf"
                      onChange={(e) => handleFileChange(e, 'application')}
                    />
                    <button type="button" className="btn-choose-file" onClick={() => document.getElementById('application').click()}>
                      Faylni tanlash
                    </button>
                    <span className="file-chosen-name">
                      {formData.documents.application ? formData.documents.application.name : 'Fayl tanlanmagan'}
                    </span>
                  </div>
                  <span className="field-hint-text">
                    Arizada imtihon topshiriladigan chet tili aniq koʻrsatilishi lozim. Hujjat turi: PDF. Maksimal hajm: 3 MB.
                  </span>
                  {errors.application && <span className="field-error-text">{errors.application}</span>}
                </div>
              </div>

              {/* Mavzuning OAK Byulletenida eʼlon qilingan nusxasi */}
              <div className="form-row-group file-field-row">
                <label className="form-label-cell" htmlFor="oakBulletin">
                  Mavzuning OAK Byulletenida eʼlon qilingan nusxasi <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <div className="file-input-wrapper">
                    <input
                      id="oakBulletin"
                      type="file"
                      accept=".pdf"
                      onChange={(e) => handleFileChange(e, 'oakBulletin')}
                    />
                    <button type="button" className="btn-choose-file" onClick={() => document.getElementById('oakBulletin').click()}>
                      Faylni tanlash
                    </button>
                    <span className="file-chosen-name">
                      {formData.documents.oakBulletin ? formData.documents.oakBulletin.name : 'Fayl tanlanmagan'}
                    </span>
                  </div>
                  <span className="field-hint-text">
                    OAK Byulletenida eʼlon qilinmagan boʻlsa, universitet Ilmiy kengashi qaroridan koʻchirma. Hujjat turi: PDF. Maksimal hajm: 3 MB.
                  </span>
                  {errors.oakBulletin && <span className="field-error-text">{errors.oakBulletin}</span>}
                </div>
              </div>

              {/* Tayanch doktorantura toʻgʻrisida maʼlumotnoma */}
              <div className="form-row-group file-field-row">
                <label className="form-label-cell" htmlFor="phd_certificate">
                  Tayanch doktorantura (PhD) talabasi ekanligi va tahsil olayotgan bosqichi toʻgʻrisida OTM yoki ITM maʼlumotnomasi.
                </label>
                <div className="form-input-cell">
                  <div className="file-input-wrapper">
                    <input
                      id="phd_certificate"
                      type="file"
                      accept=".pdf"
                      onChange={(e) => handleFileChange(e, 'phd_certificate')}
                    />
                    <button type="button" className="btn-choose-file" onClick={() => document.getElementById('phd_certificate').click()}>
                      Faylni tanlash
                    </button>
                    <span className="file-chosen-name">
                      {formData.documents.phd_certificate ? formData.documents.phd_certificate.name : 'Fayl tanlanmagan'}
                    </span>
                  </div>
                  <span className="field-hint-text">
                    Ilmiy boʻlimdan. Hujjat turi: PDF. Maksimal hajm: 3 MB.
                  </span>
                  {errors.phd_certificate && <span className="field-error-text">{errors.phd_certificate}</span>}
                </div>
              </div>

              {/* Pasport nusxasi */}
              <div className="form-row-group file-field-row">
                <label className="form-label-cell" htmlFor="passport">
                  Pasport nusxasi <span className="req-star">*</span>
                </label>
                <div className="form-input-cell">
                  <div className="file-input-wrapper">
                    <input
                      id="passport"
                      type="file"
                      accept=".pdf"
                      onChange={(e) => handleFileChange(e, 'passport')}
                    />
                    <button type="button" className="btn-choose-file" onClick={() => document.getElementById('passport').click()}>
                      Faylni tanlash
                    </button>
                    <span className="file-chosen-name">
                      {formData.documents.passport ? formData.documents.passport.name : 'Fayl tanlanmagan'}
                    </span>
                  </div>
                  <span className="field-hint-text">
                    Pasport yoki ID-karta nusxasini yuklang. Ruxsat etilgan format: PDF. Maksimal hajm: 3 MB.
                  </span>
                  {errors.passport && <span className="field-error-text">{errors.passport}</span>}
                </div>
              </div>
            </div>
          )}

          {/* Bosqich tugmalari */}
          <div className="reg-bottom-actions">
            {step > 1 ? (
              <button type="button" className="btn-step-prev" onClick={handlePrev} disabled={loading}>
                Oldingi
              </button>
            ) : <div></div>}

            {step < 3 && (
              <button type="button" className="btn-step-next" onClick={handleNext} disabled={loading}>
                Keyingi
              </button>
            )}

            {step === 3 && (
              <button type="button" className="btn-step-submit" onClick={handleSubmit} disabled={loading}>
                {loading ? 'Yuborilmoqda...' : 'Yuborish'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
